import BannerAchievements from "components/Achievements/AchievementsBanner";
import AchievementsContent from "components/Achievements/AchievementsContent";
import AchievementsOur from "components/Achievements/AchievementsOur";
import AchievementsStamp from "components/Achievements/AchievementsStamp";
import React from "react";
import { Helmet } from "react-helmet";

const Achievements = () => {
    return (
        <article>
            <Helmet>
                <title> CNP Seguros Holding Brasil | Nossas conquistas</title>
                <meta name="description" content="Após 20 anos de grandes resultados no Brasil, nosso modelo de negócio baseado na construção de multiparcerias sustentáveis e duradouras também já traz números que compartilhamos com você e com o mercado." />
                <meta name="keywords" content="CNP Seguros, CNP Holding Brasil, financeiro, multiparceria, confiança, transparência, compliance" />
            </Helmet>
            <BannerAchievements />
            <AchievementsContent />
            <AchievementsStamp />
            <AchievementsOur />
        </article>
    );
};

export default Achievements;
